import './index.css';

const ListContainer = ({ children }) => {
    return (
        <div className="list-container">
            {children}
        </div>
    )
}

export default ListContainer;